import api from './api';

const creditService = {
  /**
   * Get remaining credits for the current user
   * @param {string} userId - The user's ID
   * @returns {Promise<Object>} Object containing support and development credits
   */
  async getRemainingCredits(userId) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }
      const response = await api.get(`/users/${userId}/credits`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Get credit history for the current user
   * @param {string} userId - The user's ID
   * @param {Object} options - Query options
   * @param {number} [options.limit=10] - Max number of results
   * @param {number} [options.offset=0] - Result offset
   * @returns {Promise<Object>} Credit history with pagination
   */
  async getCreditHistory(userId, options = {}) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }
      const response = await api.get(`/users/${userId}/credit-history`, { params: options });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  /**
   * Recalculate credits for the current user
   * @param {string} userId - The user's ID
   * @returns {Promise<Object>} Updated credit information
   */
  async recalculateCredits(userId) {
    try {
      if (!userId) {
        throw new Error('User ID is required');
      }
      const response = await api.post('/user-credits/recalculate');
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

export default creditService; 